"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FiltersBar = void 0;
const MetaModelRegistry_1 = __importDefault(require("@opsbase/lib-data-metamodel/MetaModelRegistry"));
const QueryFieldKey_1 = __importDefault(require("@opsbase/lib-data-queryfield/QueryFieldKey"));
const KeyCodes_1 = __importDefault(require("@opsbase/lib-general/KeyCodes"));
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const useDataTree_1 = __importDefault(require("@opsbase/web-ctrl-datatree/useDataTree"));
const useView_1 = __importDefault(require("@opsbase/web-ctrl-view/useView"));
const useViewActions_1 = __importDefault(require("@opsbase/web-ctrl-view/useViewActions"));
const Horizontal_1 = __importDefault(require("@opsbase/web-layout/Horizontal"));
const TextField_1 = __importDefault(require("@opsbase/web-textfield/TextField"));
const react_1 = __importStar(require("react"));
const FiltersMenu_1 = __importDefault(require("../FiltersMenu"));
const FiltersList_1 = __importDefault(require("./FiltersList"));
const makeMyClasses = hasAvailFilters => ({
    tray: {
        position: 'relative',
        minHeight: 42,
        borderRadius: 6,
    },
    trayinner: {
        position: 'absolute',
        marginLeft: hasAvailFilters ? 40 : 0,
        top: 0,
        zIndex: 102,
        minHeight: 42,
        maxHeight: 42,
        width: hasAvailFilters ? 'calc(100% - 40px)' : '100%',
        overflowY: 'hidden',
        backgroundColor: '#fff',
        borderRadius: '0 6px 6px 0',
        transition: 'max-height 0.3s, border-radius 0.3s',
        border: `1px solid ${lib_palette_1.default.LineGrey.main}`,
        '&:hover': {
            maxHeight: 300,
            overflowY: 'scroll',
            borderRadius: '0 6px 6px 6px',
        },
    },
    filtersCount: {
        position: 'absolute',
        top: 0,
        right: 0,
        width: 24,
        height: 24,
        opacity: 1,
        backgroundColor: lib_palette_1.default.LineGrey.main,
        borderRadius: '0 0 0 24px',
        zIndex: 101,
        textAlign: 'right',
        padding: '2px 4px 0 0',
        fontSize: 10,
    },
    root: {
        height: '100%',
        borderRadius: '5px 0 0 5px',
    },
});
function FiltersBar({ filterableSelector, }) {
    const dt = (0, useDataTree_1.default)();
    const { filters, highlightedGroups, type } = (0, useView_1.default)(dt.viewId);
    const { toggleFilter } = (0, useViewActions_1.default)(dt.viewId);
    const { filterables } = MetaModelRegistry_1.default[type];
    const [filterText, setFilterText] = (0, react_1.useState)('');
    const availFilters = (0, react_1.useMemo)(() => {
        const available = filterables.filter(f => !f.hidden);
        if (filterableSelector) {
            return filterableSelector(available);
        }
        return available;
    }, [filterableSelector, filterables]);
    const hasAvailFilters = !!availFilters.length;
    const myCss = (0, web_css_1.default)(makeMyClasses, [hasAvailFilters]);
    const inputRef = (0, react_1.useRef)();
    const filterCount = filters.length + highlightedGroups.length;
    const handleClickFilterList = (0, react_1.useCallback)(e => {
        e.stopPropagation();
        if (inputRef.current)
            inputRef.current.focus();
    }, []);
    const handleKeyUp = (0, react_1.useCallback)(e => {
        if (e.keyCode === KeyCodes_1.default.ENTER) {
            const filter = {
                queryFieldKey: QueryFieldKey_1.default.KEYWORD,
                id: filterText,
                title: filterText,
            };
            toggleFilter(filter);
            setFilterText('');
        }
    }, [filterText, toggleFilter]);
    return (0, react_1.useMemo)(() => (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Horizontal_1.default, { justify: 'flex-start', classes: { root: myCss.tray } },
            react_1.default.createElement(FiltersMenu_1.default, { filterableSelector: filterableSelector }),
            react_1.default.createElement(Horizontal_1.default, { classes: { root: myCss.trayinner }, gutter: true, centered: true, justify: "flex-start", flexWrap: "wrap", onClick: handleClickFilterList },
                react_1.default.createElement(FiltersList_1.default, null),
                react_1.default.createElement(TextField_1.default, { inputRef: ref => (inputRef.current = ref), noBorder: true, value: filterText, onChange: setFilterText, onKeyUp: handleKeyUp, InputProps: {
                        disableUnderline: true,
                    } })),
            !!filterCount && react_1.default.createElement("div", { className: myCss.filtersCount }, filterCount)))), [filterCount, filterableSelector, filterText, handleClickFilterList, handleKeyUp, myCss]);
}
exports.FiltersBar = FiltersBar;
exports.default = FiltersBar;
